/**
 * Calendar days in Vilnius.
 *
 * The backend keeps calendar dates (invoice date, contract end) as Vilnius days
 * stored at UTC midnight. Formatting one with date-fns `format(parseISO(...))`
 * reads it in the BROWSER's zone instead — a user west of UTC then sees, and on
 * the next save sends back, the day before. Read and write these through here.
 */

const VILNIUS = "Europe/Vilnius";

/** `YYYY-MM-DD` of the Vilnius calendar day of `value`, or "" when there is none. */
export function vilniusYmd(value?: string | Date | null): string {
  if (!value) return "";
  const d = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(d.getTime())) return String(value).slice(0, 10);
  return new Intl.DateTimeFormat("en-CA", {
    timeZone: VILNIUS,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).format(d);
}

/** Today's Vilnius calendar day, `YYYY-MM-DD`. */
export function vilniusTodayYmd(): string {
  return vilniusYmd(new Date());
}
